import { configureStore, combineReducers } from "@reduxjs/toolkit";

import appState from "./app";
import formState from "./form";
import collectionState from "./collection";
import amilState from "./amil";

const rootReducer = combineReducers({
  appState,
  amilState,
  formState,
  collectionState,
});

export type RootState = ReturnType<typeof rootReducer>;

export default configureStore({
  reducer: rootReducer,
});
